import ApiService from './ApiService';

export default class NotificationApi extends ApiService {
    constructor() {
        super('notifications');
    }

    getAllNotifications(payload) {
        return this.get('', payload);
    }

    getNotificationDetail(id) {
        return this.get(id);
    }
}
